import { ButtonMain } from '@/modules/common/components/button';
import styles from './index.module.sass';
import CloseSvg from '@@/home/images/close.svg';
import { Col, Row } from 'antd';
import { InputWithSign } from '@/modules/common/components/input-with-sign';
import { useStore } from 'effector-react';
import { $buyerDraftData, setBuyerDraftData } from '../../store/buyer.store';
import { useNavigate } from 'react-router-dom';

export const RegisterShield = ({ onClose }: { onClose: () => void }) => {
  const newBuyer = useStore($buyerDraftData);
  const navigate = useNavigate();
  return (
    <div className={styles.root}>
      <div className={styles.topArea}>
        <span>регистрация покупателя</span>
        <img src={CloseSvg} alt="x" onClick={onClose} />
      </div>
      <div className={styles.contentArea}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <InputWithSign
              label="название компании*"
              postfix=""
              value={newBuyer.companyName}
              onChange={(e) =>
                setBuyerDraftData({ ...newBuyer, companyName: e.target.value })
              }
              placeholder='ООО "Ваша Компания"'
            />
          </Col>
          <Col span={12}>
            <InputWithSign
              placeholder="Россия"
              label="страна*"
              postfix=""
              value={newBuyer.country}
              onChange={(e) =>
                setBuyerDraftData({ ...newBuyer, country: e.target.value })
              }
            />
          </Col>
          <Col span={12}>
            <InputWithSign
              label="адрес компании*"
              placeholder="Регион, населенный пункт, улица/массив, дом"
              postfix=""
              value={newBuyer.address}
              onChange={(e) =>
                setBuyerDraftData({ ...newBuyer, address: e.target.value })
              }
            />
          </Col>
          <Col span={12}>
            <InputWithSign
              label="телефон*"
              placeholder="+7 ("
              onChange={(e) =>
                setBuyerDraftData({ ...newBuyer, phone: e.target.value })
              }
              postfix=""
              value={newBuyer.phone}
              autoComplete="off"
              mask={[
                '+',
                '7',
                ' ',
                '(',
                /[1-9]/,
                /\d/,
                /\d/,
                ')',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
              ]}
              blocker={false}
            />
          </Col>
          <Col span={12}>
            <InputWithSign
              label="e-mail*"
              placeholder='mail@company.com'
              postfix=""
              value={newBuyer.email}
              onChange={(e) =>
                setBuyerDraftData({ ...newBuyer, email: e.target.value })
              }
            />
          </Col>
          <Col span={12}>
            <InputWithSign
              label="ИНН"
              postfix=""
              placeholder=''
              value={newBuyer.inn}
              onChange={(e) =>
                setBuyerDraftData({
                  ...newBuyer,
                  inn: e.target.value.replace(/\D/g, ''),
                })
              }
            />
          </Col>
          <Col span={12}>
            <InputWithSign
              label="ОГРН"
              placeholder=''
              postfix=""
              value={newBuyer.ogrn}
              onChange={(e) =>
                setBuyerDraftData({
                  ...newBuyer,
                  ogrn: e.target.value.replace(/\D/g, ''),
                })
              }
            />
          </Col>
        </Row>
      </div>
      <div className={styles.actionArea}>
        <ButtonMain className={styles.button} label="продолжить" onClick={() => navigate('/buyer-points')} />
      </div>
    </div>
  );
};
